import { useMemo } from 'react';
import { TListboxContext } from './ListboxContext';

export function useListboxContextValue(props: TListboxContext) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => props, [...Object.values(props)]);
}
